// extracted by mini-css-extract-plugin
export default {"primaryBtn":"style_primaryBtn__gf9uk","secondaryBtn":"style_secondaryBtn__BmuwE","dangerBtn":"style_dangerBtn__laWlu"};